import ErrorNodeWrapper from '@/components/validation/ErrorNodeWrapper';
import { useApplication } from '@/hooks/useApplication';
import { useMetadataBlock } from '@/hooks/useMetadataBlock';
import { isNumber } from '@/util/typeGuards';
import { validatePort } from '@/util/validation/validation';
import { Stack } from '@mui/material';
import { FC } from 'react';
import ConnectionsRenderer from './actions/ConnectionsRenderer';
import PortSelect from './actions/PortSelect';

type ActionsViewProps = {
  id: number;
  parentId: number;
};

const ActionsView: FC<ActionsViewProps> = (props) => {
  const { application } = useApplication();
  const { metadataBlock } = useMetadataBlock();

  const ports = metadataBlock?.output_ports ?? [];
  const index = application.blocks.portoptions[props.id]?.index ?? 0;
  const type = ports[index]?.type ?? 'fixed';

  const portValidate = () => {
    if (ports.length < 2 || !isNumber(application.blocks.portoptions[props.id]?.index)) return;
    return validatePort(props.id, application.blocks.portoptions[props.id].index, ports);
  };

  return (
    <Stack gap={2} pt={1}>
      <ErrorNodeWrapper errors={portValidate()}>
        <PortSelect id={props.id} ports={ports} index={index} />
      </ErrorNodeWrapper>
      <ConnectionsRenderer id={props.id} type={type} portOption={ports[index]} />
    </Stack>
  );
};

export default ActionsView;
